const generateNumberArray = (min: number, max: number, reverse?: boolean): number[] => {
	const array: number[] = [];
	for (let i = min; i <= max; i++) {
		array.push(i);
	}
	return reverse ? array.reverse() : array;
};

export default generateNumberArray;
